import _ from 'lodash';
import { ensureModulesObjects } from './modulesConversion';
// import { generateShortUUID } from '@skygroup/shared/utils/generateRandomString';

const isNullishOrEmptyObject = (val: any) =>
  val == null ||
  (typeof val === 'object' &&
    !Array.isArray(val) &&
    Object.keys(val).length === 0);

export function replaceStringElementInArr({
  arr,
  oldVal,
  newVal,
}: {
  arr: string[];
  oldVal: string;
  newVal: string;
}): string[] {
  return arr.map((item) => (item === oldVal ? newVal : item));
}

export function insertAt(array: any, index: number, value: string) {
  return [..._.slice(array, 0, index), value, ..._.slice(array, index)];
}

export function replaceAt(array: any[], index: number, value: any): any[] {
  let newArray = [...array];
  newArray[index] = value;
  return newArray;
}

export function pagesWithSamePath(
  path1: string | string[],
  path2: string | string[]
): boolean {
  if (typeof path1 == 'string' && typeof path2 == 'string') {
    return path1 === path2;
  }
  if (
    path1.length !== path2.length ||
    !Array.isArray(path1) ||
    !Array.isArray(path2)
  ) {
    return false;
  }
  return path1.sort().join() === path2.sort().join();
}

// export function deepMerge(target, source) {
//   for (const key in source) {
//     // Handle 'theme' key specifically
//     if (key === 'theme') {
//       target[key] = source[key];
//       continue;
//     }
//     if (
//       source[key] &&
//       typeof source[key] === 'object' &&
//       !Array.isArray(source[key])
//     ) {
//       if (!target[key]) {
//         target[key] = {};
//       }
//       deepMerge(target[key], source[key]);
//     } else if (source[key]) {
//       target[key] = source[key];
//     }
//   }
//   return target;
// }
export function updateNestedValue(obj: any, path: string[], value: any): any {
  if (path.length === 0) return obj; // If path is empty, return original object
  const [firstKey, ...restKeys] = path;
  return {
    ...(obj || {}),
    [firstKey]: restKeys?.length
      ? updateNestedValue(obj?.[firstKey] || {}, restKeys, value) // Recursively update deeper
      : value, // Set new value at final depth
  };
}

export interface NewSelectedModuleType {
  index: number;
  moduleName: string;
  instance: string;
  pageUpdatedModules: string[] | [];
  newDupInstance: any;
}
export interface HandleCreateDupInstanceReturnType {
  finalValue: any;
  newSelectedModule: NewSelectedModuleType;
}

export function updateWhiteLabelPage({
  pagesArr,
  oldVal,
  newVal,
  selectedPageId,
  siteDefaultConfigPages,
}: {
  pagesArr: any[];
  oldVal: string;
  newVal: string;
  selectedPageId: string;
  siteDefaultConfigPages: any[];
}) {
  let pageUpdatedModules = null;
  const updatedPages = pagesArr?.map((page) => {
    if (page.id !== selectedPageId && page.name !== selectedPageId) {
      return page;
    }

    pageUpdatedModules = replaceStringElementInArr({
      arr: page.modules,
      oldVal,
      newVal,
    });

    return {
      ...page,
      modules: pageUpdatedModules,
    };
  });

  return { updatedPages, pageUpdatedModules };
}

export function attachNewPageToWhiteLabel({
  pagesArr,
  oldVal,
  newVal,
  selectedPageId,
  siteDefaultConfigPages,
}: {
  pagesArr: any[];
  oldVal: string;
  newVal: string;
  selectedPageId: string;
  siteDefaultConfigPages: any[];
}) {
  const newPageElement = siteDefaultConfigPages?.find(
    (page) => page.id === selectedPageId || page.name === selectedPageId
  );
  if (!newPageElement) {
    return { updatedPages: pagesArr, pageUpdatedModules: null };
  }

  const pageUpdatedModules = replaceStringElementInArr({
    arr: newPageElement.modules,
    oldVal,
    newVal,
  });

  return {
    updatedPages: [
      ...pagesArr,
      {
        ...newPageElement,
        modules: pageUpdatedModules,
      },
    ],
    pageUpdatedModules,
  };
}
const idOf = (m: any) => m?.module ?? m?.instance ?? null;

function replaceFirstInstanceInArr(arr: any[] = [], oldVal: string, newVal: string) {
  if (!Array.isArray(arr)) return arr;
  let replaced = false;
  return arr.map((item) => {
    const id = typeof item === 'string' ? item : idOf(item);
    if (!replaced && id === oldVal) {
      replaced = true;
      return newVal;
    }
    // keep original string form for the pageUpdatedModules result
    return typeof item === 'string' ? item : id;
  });
}

export function handleCreateDupInstanceType({
  prev,
  currSiteDefaultConfig,
  iframeWindow,
  selectedModuleInfo,
  selectedPage,
  siteDefaultConfig,
}: {
  prev: any;
  currSiteDefaultConfig: any;
  iframeWindow: any;
  selectedModuleInfo: any;
  selectedPage: any;
  siteDefaultConfig: any;
}): HandleCreateDupInstanceReturnType {
  const isLayoutModule = !!selectedModuleInfo?.layoutSection;
  const original_instance =
    selectedModuleInfo?.instance || selectedModuleInfo?.module;
  const newInstance = `${original_instance}_dup`;
  const newDupInstance = {
    ...currSiteDefaultConfig,
    original_instance,
    instance: newInstance,
  };

  // We'll operate on a copy of prev.pages (immutable)
  const prevPagesCopy = Array.isArray(prev?.pages) ? prev.pages.slice() : [];
  let updatedPages = prevPagesCopy;
  let pageUpdatedModules: string[] | null = null;
  // ----- NEW: annotate EVERY WL page module that matches original_instance -----
  try {
    const normalize = (arr: any[] | undefined) =>
      ensureModulesObjects(arr || []);
    const idOf = (m: any) => m?.module ?? m?.instance ?? null;

    // walk through all pages in updatedPages (which may already contain copies created by ensureModuleCopiedToWhiteLabel)
    updatedPages = (updatedPages || []).map((wlPage: any) => {
      if (!wlPage) return wlPage;
      const wlModules = normalize(wlPage.modules || []);
      let changed = false;
      const newModules = wlModules.map((m: any) => {
        const mid = idOf(m);
        if (mid === original_instance) {
          // set/merge overrideModuleName & fromParentWebsite
          changed = true;
          return {
            ...(m || {}),
            module: original_instance,
            sort_index: m?.sort_index ?? null,
            fromParentWebsite: true,
            overrideModuleName: newDupInstance.instance,
          };
        }
        return m;
      });
      return changed ? { ...wlPage, modules: newModules } : wlPage;
    });

    // also ensure pages that were not present in updatedPages but present in pagesState (selectedPage was already handled by ensureModuleCopied...)
    // were added by ensureModuleCopiedToWhiteLabel earlier. If you still need to create minimal pages for pagesState entries
    // you can add it here; but ensureModuleCopiedToWhiteLabel already does that.
  } catch (err) {
    console.error('annotating WL pages for dup failed', err);
  }
  if (isLayoutModule) {
    // Layout modules: keep previous behavior (delegated)
    const layoutsArr = prev?.layouts?.length
      ? prev.layouts
      : siteDefaultConfig.layouts;
    const updatedLayouts = handleUpdateLayoutModules({
      prev,
      renderedLayoutArr:
        layoutsArr?.[selectedPage?.layout]?.[selectedModuleInfo?.layoutSection],
      selectedPage,
      selectedModuleInfo,
      newDupInstance,
    });

    // final value assembly below
    updatedPages = prevPagesCopy;
    pageUpdatedModules = null;
    const finalValue = {
      ...prev,
      modulesConfigs: {
        ...prev.modulesConfigs,
        [newDupInstance.instance]: newDupInstance,
      },
      pages: updatedPages,
    };

    // replaceIndex calculation for caller
    const replaceIndex = (selectedPage?.modules || []).findIndex(
      (instance: any) => {
        if (typeof instance === 'string')
          return instance === newDupInstance.original_instance;
        return (
          (instance?.module ?? instance?.instance) ===
          newDupInstance.original_instance
        );
      }
    );

    return {
      finalValue,
      newSelectedModule: {
        index: replaceIndex,
        moduleName: newDupInstance.module,
        instance: newDupInstance.instance,
        newDupInstance,
        pageUpdatedModules: pageUpdatedModules || [],
      },
    };
  }

  // Non-layout pages: insert/annotate parent module in WL pages, and compute pageUpdatedModules for UI
  try {
    // ensure pages array is at least an array
    const pagesArr = updatedPages || [];

    // find index of target page in WL pages (if exists)
    const wlPageIndex = pagesArr.findIndex(
      (p: any) =>
        p &&
        (p.id === selectedPage.id ||
          pagesWithSamePath(p.path, selectedPage.path))
    );

    // Prepare parent module entry (use selectedPage modules to preserve sort_index)
    const selectedPageModulesNormalized = ensureModulesObjects(
      selectedPage?.modules || []
    );
    const sourceModuleObj = selectedPageModulesNormalized.find(
      (m: any) => idOf(m) === original_instance
    );

    const parentModuleEntry = {
      module: original_instance,
      sort_index: sourceModuleObj?.sort_index ?? null,
      fromParentWebsite: true,
      overrideModuleName: newDupInstance.instance,
    };

    if (wlPageIndex >= 0) {
      // Page exists in WL -> upsert the parent module object (merge)
      const wlPage = pagesArr[wlPageIndex];
      const wlModules = ensureModulesObjects(wlPage.modules || []);
      const foundIdx = wlModules.findIndex(
        (m: any) => idOf(m) === original_instance
      );

      let newModules;
      if (foundIdx >= 0) {
        const copy = wlModules.slice();
        copy[foundIdx] = { ...(copy[foundIdx] || {}), ...parentModuleEntry };
        newModules = copy;
      } else {
        newModules = [...wlModules, parentModuleEntry];
      }

      updatedPages = [
        ...pagesArr.slice(0, wlPageIndex),
        { ...wlPage, modules: newModules },
        ...pagesArr.slice(wlPageIndex + 1),
      ];
    } else {
      // WL page not present -> create minimal WL page using selectedPage and add parent entry
      const newWLPage = {
        ...selectedPage,
        id: selectedPage.id ?? selectedPage.name,
        modules: [parentModuleEntry],
      };
      updatedPages = [...pagesArr, newWLPage];
    }

    // Build pageUpdatedModules for UI: replace first occurrence of original_instance with newInstance
    const pageModulesAsStrings = (selectedPage?.modules || []).map((m: any) =>
      typeof m === 'string' ? m : idOf(m)
    );
    pageUpdatedModules = replaceFirstInstanceInArr(
      pageModulesAsStrings,
      original_instance,
      newInstance
    );
  } catch (err) {
    console.error(
      'handleCreateDupInstanceType: failed to insert parent module into WL page',
      err
    );
    // fallback: do not change pages but still create modulesConfigs entry
    updatedPages = prevPagesCopy;
    pageUpdatedModules = null;
  }

  // assemble final value
  const finalValue = {
    ...prev,
    modulesConfigs: {
      ...prev.modulesConfigs,
      [newDupInstance.instance]: newDupInstance,
    },
    pages: updatedPages,
  };

  // compute replaceIndex for caller (where selectedPage.modules is original)
  const replaceIndex = (selectedPage?.modules || []).findIndex(
    (instance: any) => {
      if (typeof instance === 'string')
        return instance === newDupInstance.original_instance;
      return (
        (instance?.module ?? instance?.instance) ===
        newDupInstance.original_instance
      );
    }
  );

  return {
    finalValue,
    newSelectedModule: {
      index: replaceIndex,
      moduleName: newDupInstance.module,
      instance: newDupInstance.instance,
      newDupInstance,
      pageUpdatedModules: pageUpdatedModules || [],
    },
  };
}


export interface HandleEditModuleReturnType {
  finalValue: any;
  newSelectedModule: null;
}

export function handleEditModule({
  prev,
  // currWhiteLabelConfig,
  // currSiteDefaultConfig,
  path,
  value,
  iframeWindow,
  selectedModuleInfo,
}: {
  prev: any;
  path: string[];
  value: any;
  iframeWindow: any;
  selectedModuleInfo: any;
}): HandleEditModuleReturnType {
  // if instance exists within WhiteLabel just update its state + do iframe.postMessage for "EditModule"
  const currWhiteLabelConfig =
    prev.modulesConfigs[selectedModuleInfo?.instance];

  const updatedWhiteLabelConfig = updateNestedValue(
    currWhiteLabelConfig,
    path,
    value
  );
  const finalValue = {
    ...prev,
    modulesConfigs: {
      ...prev.modulesConfigs,
      [selectedModuleInfo?.instance]: updatedWhiteLabelConfig,
    },
  };

  // const updatedConfig = updateNestedValue(currSiteDefaultConfig, path, value);
  iframeWindow?.postMessage(
    {
      type: 'EditModule',
      [selectedModuleInfo?.instance]: updatedWhiteLabelConfig,
    },
    '*'
  );

  return { finalValue, newSelectedModule: null };
}

export function handleUpdatePageModules({
  prev,
  renderedLayoutArr,
  selectedPage,
  selectedModuleInfo,
  newDupInstance,
}: {
  prev: any; // configInterface;
  renderedLayoutArr: string[];
  selectedPage: pagesInterface;
  selectedModuleInfo: {
    moduleName: string;
    instance: string;
    layoutSection?: string;
    pageId?: string;
    index?: number;
  };
  newDupInstance: any;
}) {
  const updatedPages = prev.pages.map((page: any) => {
    if (
      page.allow_edit !== false &&
      ((page.id && page.id === selectedPage.id) ||
        pagesWithSamePath(page.path, selectedPage.path))
    ) {
      const updatedPageModules = replaceStringElementInArr({
        arr: page.modules,
        oldVal: newDupInstance.original_instance,
        newVal: newDupInstance.instance,
      });
      return {
        ...page,
        modules: updatedPageModules,
        id: selectedPage.id,
      };
    }
    return page;
  });

  return updatedPages;
}

// Later import it from shared !!!!
interface pagesInterface {
  id: string;
  name: string;
  path: string;
  modules: string[];
  layout: string;
  type: string;
  seo: {
    title: string;
    desc: string;
  };
  allow_edit?: boolean;
}

export function handleUpdateLayoutModules({
  prev,
  renderedLayoutArr,
  selectedPage,
  selectedModuleInfo,
  newDupInstance,
}: {
  prev: any; // configInterface;
  renderedLayoutArr: string[];
  selectedPage: pagesInterface;
  selectedModuleInfo: {
    moduleName: string;
    instance: string;
    layoutSection?: string;
    pageId?: string;
    index?: number;
  };
  newDupInstance: any;
}) {
  const updatedLayoutSection = !isNullishOrEmptyObject(prev?.layouts)
    ? replaceStringElementInArr({
        arr: renderedLayoutArr,
        oldVal: newDupInstance.original_instance,
        newVal: newDupInstance.instance,
      })
    : [newDupInstance.instance];

  if (!selectedModuleInfo?.layoutSection) {
    return prev?.layouts;
  }

  const updatedLayouts = {
    ...(prev?.layouts ?? {}),
    [selectedPage?.layout]: {
      ...prev?.layouts?.[selectedPage?.layout],
      [selectedModuleInfo?.layoutSection]: updatedLayoutSection,
    },
  };

  return updatedLayouts;
}
